<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Produto</h4>
      </div>
      <div v-if="showMatriz">
        <el-select
          class="select-default"
          size="large"
          placeholder="Selecione a categoria - Filial"
          v-validate="modelValidations.category"
          v-model="model.category"
        >
          <el-option
            v-for="option in categories"
            class="select-danger"
            :value="option.id"
            :label="option.name + ' - ' + option.company_name"
            :key="option.id"
          ></el-option>
        </el-select>
        <div class="text-danger invalid-feedback"
          ref="alertCategory"
          style="display: none; margin-top: -5px">Categoria obrigatório</div>
        </div>
        <div v-if="!showMatriz" > 
          <el-select
            class="select-default"
            size="large"
            placeholder="Selecione a categoria"
            v-validate="modelValidations.category"
            v-model="model.category"
          >
            <el-option
              v-for="option in categories"
              class="select-danger"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertCategory"
            style="display: none; margin-top: -5px">Categoria obrigatório</div>
        </div>

        <fg-input
          name="name"
          label="Nome"
          v-validate="modelValidations.name"
          v-model="model.name"
          :error="getError('name')"
        ></fg-input>
        <fg-input label="Descrição">
          <textarea
            class="form-control"
            v-model="model.description"
            placeholder="Escreva aqui..."
            rows="3"
          ></textarea>
        </fg-input>

        <fg-input v-if="showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="model.company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input
          name="limit"
          type="number"
          label="Limite de venda"
          v-validate="modelValidations.limit"
          v-model="model.limit"
          :error="getError('limit')"
        ></fg-input>


        <fg-input 
            label="Preço de custo">
          <fg-input
            name="priceCost"
            @blur="putPrice(vm)"
            v-validate="modelValidations.priceCost"
            v-model="model.cost_price"
            :error="getError('priceCost')"
          >
            <span slot="addonLeft">R$</span>
          </fg-input>
        </fg-input>

        <fg-input
          name="sku"
          label="SKU"
          v-validate="modelValidations.sku"
          @input="skuExist(model.sku)"
          v-model="model.sku"
          :error="getError('sku')"
        ></fg-input>

          <el-checkbox v-model="model.controlled">Produto controlado</el-checkbox>
    </card>
    <!-- PREÇOS POR VM -->
    <div v-if="showPrices && countVariant == 0">
      <card v-if="(variants.length == 0 || variants == {} )">
        <div slot="header">
          <h5 class="card-title">Preço por Vending Machine e Lockers</h5>
        </div>
        <div v-if="vms"> 
          <div>
            <label style="margin-bottom: 15px">Vending Machines</label>
          </div>
          <div v-for="vm in vms" :key="vm.index" style="margin-left: 15px" class="row">
            <div class="col-sm-2"> 
              <span style="size: 0.4rem">{{vm.location}}</span>
            </div>
            <div class="col-sm-6">
              <fg-input >
                <fg-input
                  name="price"
                  @blur="putPrice(vm)"
                  v-validate="modelValidations.price"
                  v-model="pricesVM[vm.id]"
                  :error="getError('price')"
                  class="col-sm-5"
                >
                  <span slot="addonLeft">R$</span>
                </fg-input>
              </fg-input>
            </div>
          </div>
        </div>
        <div v-if="lockers.length > 0">
          <div>
            <label style="margin-bottom: 15px">Lockers</label>
          </div>
          <div v-for="lock in lockers" :key="lock.index" style="margin-left: 15px" class="row">
            <div class="col-sm-2"> 
              <span style="size: 0.4rem">{{lock.location}}</span>
            </div>
            <div class="col-sm-6">
              <fg-input >
                <fg-input
                  name="price"
                  @blur="putPrice(lock)"
                  v-validate="modelValidations.price"
                  v-model="pricesVM[lock.id]"
                  :error="getError('price')"
                  class="col-sm-5"
                >
                  <span slot="addonLeft">R$</span>
                </fg-input>
              </fg-input>
            </div>
          </div>
        </div>
      </card>
    </div>
    <!-- CARD IMAGENS -->
    <card v-if="showImage" class="col-sm-12">
      <div>
        <label>Imagens</label>
      </div>
      <div class="img-upload">
        <div class="col-sm-12 row">
          <div v-for="(i, k) in imagesAPI" :key="k" class="col-sm-6">
            <img :src="i.image" alt style="padding: 15px" class="col-sm-12">
            <l-button @click.prevent="delImage(i.id)" round class="btn-danger btn col-sm-1">
              <i class="fa fa-times"></i>
            </l-button>
          </div>
        </div>
        <div class="col-sm-12">
          <l-button
            v-if="countAttribute === 0"
            size="sm"
            class="btn btn-social btn-round btn-outline btn-info"
            @click="$refs.SelectImage.click()"
          >Adicionar nova imagem</l-button>
          <input
            name="image"
            style="display: none"
            label="Image"
            type="file"
            ref="SelectImage"
            accept="image/*"
            multiple
            @change="onChange"
            class="col-sm-12"
          >
        </div>
        <div v-for="(i, k) in images" :key="k" class="div-img col-sm-6">
          <img :src="i.image" alt>
          <l-button
            style="margin-left: 15px"
            @click.prevent="removeImage(k)"
            round
            class="btn-danger btn col-sm-1"
          >
            <i class="fa fa-times"></i>
          </l-button>
        </div>
      </div>
      <!-- <el-upload
        action="#"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt>
      </el-dialog>-->
    </card>
    <card v-else>
      Atualizando fotos .....
    </card>
    <card v-if="showVideo" class="col-sm-12">
      <div>
        <label>Videos</label>
      </div>
      <div class="img-upload" v-if="showVideo">
        <div class="col-sm-12 row">
          <div v-for="video in videos" :key="video.id" class=" col-sm-6">
            <video :src="video.video" width="320" height="240" 
              controls class="col-sm-12 " style="padding: 15px; margin-top: 15px" >
            </video>
            <l-button  @click.prevent="delVideo(video.id)" round class=" btn-danger btn col-sm-1 offset-sm-6">
              <i class="fa fa-times"></i>
            </l-button>
          </div>
        </div>
        <l-button  
          v-if="countAttribute === 0"
          size="sm" 
          class="btn btn-social btn-round  btn-outline btn-info"
          @click="$refs.SelectFile.click()"
        >Adicionar novo video
        </l-button>
        <input 
          name="video"
          style="display: none" 
          label="Image" 
          type="file" 
          ref="SelectFile" 
          accept="video/*" 
          @change="selectFile" multiple >
        <div class="col-sm-12 row">
          <div v-for="(path, index) in paths" :key="path.index" class="col-sm-6" >
            <video v-if="hasVideo" :src="path" width="320" height="240" 
              controls style="padding: 15px" class="col-sm-12">
            </video>
            <l-button  @click.prevent="removeVideo(index)" round class=" btn-danger btn col-sm-1 offset-sm-6">
              <i class="fa fa-times"></i>
            </l-button>
          </div>
        </div>
      </div>
    </card>
    <card v-else>
      Atualizando videos ....
    </card>
    <div v-if="crud === 'Editar'">
      <card title="Variações" v-if="showVariant">
        <el-collapse v-for="(variant, i) in variants" :key="variant.key">
          <el-collapse-item :title="variant.name" name="1">
            <fg-input
              name="name"
              label="Nome"
              v-validate="modelValidations.name"
              v-model="variant.name"
              :error="getError('name')"
            ></fg-input>
              <div class="row">
                <fg-input
                  name="sku"
                  label="SKU"
                  class="col-sm-12"
                  v-validate="modelValidations.sku"
                  @input="skuExist(variant.sku)"
                  v-model="variant.sku"
                  :error="getError('sku')"
                ></fg-input>
                <div class="col-sm-12" v-if="vms"> 
                  <div>
                    <label style="margin-bottom: 15px">Preço nas Vending Machines e Lockers</label>
                  </div>
                  <div v-for="prices in variant.vmprice" :key="prices.index" style="margin-left: 15px" class="row">
                    <div class="col-sm-2"> 
                      <span style="size: 0.4rem">{{prices.vm_location}}</span>
                    </div>
                    <div class="col-sm-5">
                      <!-- <div v-for="prices in variant.vmprice" :key="prices.index">
                      {{prices.vm_location}}{{prices.price}}
                      </div> -->
                      <fg-input >
                        <fg-input
                          name="price"
                          v-validate="modelValidations.price"
                          v-model="prices.price"
                          :error="getError('price')"
                          class="col-sm-5"
                        >
                          <span slot="addonLeft">R$</span>
                        </fg-input>
                      </fg-input>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-sm-12" v-if="lockers.length > 0">
                  <div>
                    <label style="margin-bottom: 15px">Preço nos Lockers</label>
                  </div>
                  <div v-for="lock in lockers" :key="lock.index" style="margin-left: 15px" class="row">
                    <div class="col-sm-2"> 
                      <span style="size: 0.4rem">{{lock.location}}</span>
                    </div>
                    <div class="col-sm-6">
                      <fg-input >
                        <fg-input
                          name="price"
                          @blur="putPriceVar(lock)"
                          v-validate="modelValidations.price"
                          v-model="pricesVMVar[lock.id]"
                          :error="getError('price')"
                          class="col-sm-5"
                        >
                          <span slot="addonLeft">R$</span>
                        </fg-input>
                      </fg-input>
                    </div>
                  </div>
                </div> -->
                <label class="col-sm-12">Atributos :</label>
                <div
                  v-for="(variacao, index) in variant.attributes"
                  :key="variacao.index"
                  class="col-sm-12 row"
                >
                  <div class="col-sm-11">
                    <fg-input
                      name="Tipo"
                      :label="index"
                      class="col-sm-12"
                      v-model="attributeValue[i][index]"
                    ></fg-input>
                  </div>
                  <div class="remove-attribute">
                    <l-button
                      @click.prevent="deleteAttribute(variant, attributeValue[i][index], index)"
                      class="btn btn-social btn-round btn-outline btn-danger"
                    >
                      <i class="fa fa-times"></i>
                    </l-button>
                  </div>
                </div>
                <div class="col-sm-12">
                  <l-button
                    v-if="countAttribute === 0"
                    size="sm"
                    class="btn btn-social btn-round btn-outline btn-info"
                    @click.prevent="addAttribute()"
                  >Adicionar novo atributo</l-button>
                  <l-button
                    v-if="countAttribute !== 0"
                    size="sm"
                    class="btn btn-social btn-round btn-outline btn-danger"
                    style="margin-left: 15px"
                    @click.prevent="removeAttribute()"
                  >Remover novo atributo</l-button>
                </div>
                <!-- Editar atributo -->
                <div v-for="n in countAttribute" :key="n.index" class="col-sm-12 row ">
                  <div class="col-sm-11 row">
                    <fg-input
                      name="Tipo"
                      label="Tipo"
                      class="col-sm-6"
                      v-model="typeAttribute[n-1]"
                    ></fg-input>   
                    <fg-input
                      name="Valor"
                      label="Valor"
                      class="col-sm-6"
                      v-model="valueAttribute[n-1]"
                    ></fg-input> 
                  </div>
                  <div class="col-sm-1">
                    <l-button  
                      size="sm" 
                      class="btn btn-social btn-round btn-outline btn-success" 
                      style="margin-top: 35px"
                      @click.prevent="saveEditAttribute(variant, i, n-1)"
                    >
                      <i class="fa fa-check"></i>
                    </l-button>
                  </div>
                  <div id="linha">
                  </div>
                </div>
              </div>
            <!-- </fg-input> -->
            <div class="row">
              <div class="col-sm-5"></div>
              <l-button  
                size="sm" 
                class="btn btn-social btn-round btn-outline btn-danger" 
                style="margin-left: 15px"
                @click.prevent="deleteVariant(variant)"
              >Arquivar variação
              </l-button>
            </div>
          </el-collapse-item>
        </el-collapse>
        <l-button 
          v-if="countVariant === 0" 
          class="btn btn-social btn-round  btn-outline btn-info" 
          style="margin-left: 15px; margin-top: 20px"
          @click.prevent="addVariant()"
        >Adicionar variação
        </l-button>
        <l-button  
          v-if="countVariant !== 0"
          size="sm"
          class="btn btn-social btn-round btn-outline btn-danger"
          style="margin-left: 15px; margin-top: 20px"
          @click.prevent="removeVariant()"
        >Cancelar adição
        </l-button>
        <div v-if="countVariant !== 0">
          <div v-for="n in countVariant" :key="n.index" class="row">
            <fg-input
              name="name"
              label="Nome"
              class="col-sm-12"
              v-validate="modelValidations.name"
              v-model="variantName[n-1]"
              :error="getError('name')"
            ></fg-input>
            <fg-input
              name="sku"
              label="SKU"
              class="col-sm-12"
              v-validate="modelValidations.sku"
              @input="skuExist(variantSku[n-1])"
              v-model="variantSku[n-1]"
              :error="getError('sku')"
            ></fg-input>
            <!-- Novo Atributo -->
            <div class="col-sm-12">
              <l-button
                size="sm"
                class="btn btn-social btn-round btn-outline btn-info"
                @click.prevent="addAttribute()"
              >Adicionar atributo</l-button>
              <l-button
                v-if="countAttribute !== 0"
                size="sm"
                class="btn btn-social btn-round btn-outline btn-danger"
                style="margin-left: 15px"
                @click.prevent="removeAttribute()"
              >Cancelar ultima adição</l-button>
            </div>
            <div v-for="i in countAttribute" :key="i.index" class="row col-sm-12">
              <fg-input
                name="Tipo"
                label="Tipo"
                class="col-sm-6"
                v-model="typeVariant[i-1]"
              ></fg-input>   
              <fg-input
                name="Valor"
                label="Valor"
                class="col-sm-6"
                v-model="valueVariant[i-1]"
              ></fg-input> 
              <div id="linha">
              </div>
            </div>
          </div>
        </div>
      </card>
      <card v-else> Atualizando lista ....</card>
    <!-- PREÇOS POR VM -->
    <card v-if="countVariant !== 0">
      <div slot="header">
        <h5 class="card-title">Preço da variação por Vending Machine e Lockers</h5>
      </div>
      <div v-if="vms"> 
        <div>
          <label style="margin-bottom: 15px">Vending Machines</label>
        </div>
        <div v-for="vm in vms" :key="vm.index" style="margin-left: 15px" class="row">
          <div class="col-sm-2"> 
            <span style="size: 0.4rem">{{vm.location}}</span>
          </div>
          <div class="col-sm-6">
            <fg-input >
              <fg-input
                name="price"
                @blur="putPriceVar(vm)"
                v-validate="modelValidations.price"
                v-model="pricesVMVar[vm.id]"
                :error="getError('price')"
                class="col-sm-5"
              >
                <span slot="addonLeft">R$</span>
              </fg-input>
            </fg-input>
          </div>
        </div>
      </div>
      <div v-if="lockers.length > 0">
        <div>
          <label style="margin-bottom: 15px">Lockers</label>
        </div>
        <div v-for="lock in lockers" :key="lock.index" style="margin-left: 15px" class="row">
          <div class="col-sm-2"> 
            <span style="size: 0.4rem">{{lock.location}}</span>
          </div>
          <div class="col-sm-6">
            <fg-input >
              <fg-input
                name="price"
                @blur="putPriceVar(lock)"
                v-validate="modelValidations.price"
                v-model="pricesVMVar[lock.id]"
                :error="getError('price')"
                class="col-sm-5"
              >
                <span slot="addonLeft">R$</span>
              </fg-input>
            </fg-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-5"></div>
        <l-button
          v-if="crud === 'Editar'"
          type="success"
          class="btn btn-social btn-round btn-outline btn-success"
          style="margin-left: 15px; margin-top: 20px"
          @click.prevent="firstPass()"
        >Salvar variação</l-button>
      </div>
    </card>
    </div>
      <card>
      <div>
        <el-button type="primary" :loading="btnLoading" 
          @click.prevent="validate">Salvar</el-button>
        <!-- <button type="submit"   class="btn btn-fill btn-info btn-wd">Salvar</button> -->
        <el-checkbox style="float: right; margin-top: 10px" v-model="btnDissmiss">Desativar alerta</el-checkbox>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option, Button, Upload, Dialog, Collapse, CollapseItem, Checkbox } from "element-ui";
import swal from "sweetalert2";
import { Validator } from "vee-validate";

var skuDB = true

Validator.extend("unique", {
  validate: value =>
  new Promise(resolve => {
    setTimeout(() => {
      
      if (skuDB) {
        return resolve({
          valid: true
        });
      }

      return resolve({
        valid: false,
        data: {
          message: `${value} já esta sendo usado.`
        }
      });
    }, 600);
  }),
  getMessage: (field, params, data) => data.message
});

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Upload.name]: Upload,
    [Dialog.name]: Dialog,
    [Collapse.name]: Collapse,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CollapseItem.name]: CollapseItem
  },
  created() {
    var ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.model.company = Number(ciaID)
    } else if (this.showMatriz){
      ciaID = ''
    } else {
      ciaID = ''
    }
    this.getListCompany()
      this.$store.dispatch("categories/listSort",{sort: '?company=' + ciaID}).then(() => {
        if (this.$route.params.id) {
          this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID}).then(() => {
            this.model = this.$store.state.products.products.find(
              e => e.id == this.$route.params.id
            );
            this.$store.dispatch("products/images/listSort",{sort: '?company=' + ciaID}).then(data => {
              this.imagesAPI = this.$store.state.products.images.images.filter(
                e => e.product == this.$route.params.id
              );
              this.$store.dispatch("products/variants/listSort",{sort: '?company=' + ciaID}).then(data => {
                this.variants = this.$store.state.products.variants.variants.filter(
                  e => e.product == this.$route.params.id
                );
                this.ajustVariant()
                this.attributesList();
                this.$store.dispatch("products/videos/listSort",{sort: '?company=' + ciaID}).then(data => {
                  this.videos = this.$store.state.products.videos.videos.filter(
                    e => e.product == this.$route.params.id
                  );
                });
              });
            });
          });
          this.crud = "Editar";
        } else {
          this.crud = "Criar";
        }
      });
  },
  computed: {
    categories() {
      return this.$store.state.categories.categories;
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach === 'true') {
        return true
      } else {
        return false
      }
    }
  },
  data() {
    return {
      crud: "Editar",
      dialogImageUrl: "",
      btnDissmiss: false,
      btnLoading: false,
      showPrices: false,
      attributeValue: [],
      pricesVariants: [],
      companyList: [],
      dialogVisible: false,
      images: [],
      idCia: '',
      pricesVM : [],
      pricesVMVar: [],
      showImage: true,
      showVideo: true,
      showVariant: true,
      flag: false,
      imagesAPI: [],
      videosAPI: [],
      videos: [],
      countVariant: 0,
      countAttribute: 0,
      variantName: [],
      vms: [],
      lockers: [],
      finalPrice: [],
      finalPriceVar: [],
      selectedFile: [],
      variantSku: [],
      hasImage: false,
      hasVideo: false,
      variantPrice_override: [],

      newVariant: {},
      valueVariant: [],
      paths: [],
      typeVariant: [],
      typeAttribute: [],
      valueAttribute: [],
      variants: [],
      companyList: [],
      attributes: {
        type: [],
        value: []
      },
      model: {
        category: "",
        name: "",
        limit: 100,
        price: 0.00,
        sku: "",
        description: "",
        controlled: false,
        company: ''
      },
      modelValidations: {
        name: {
          required: true
        },
        category: {
          required: true
        },
        sku: {
          unique: true
        },
        limit: {
          decimal: true
        },
        price: {
          required: true,
          regex: /^[0-9]+((,|.)[0-9]{2}){1}$/
        },
        priceCost: {
          regex: /^[0-9]+((,|.)[0-9]{2}){1}$/
        },
      }
    };
  },
  mounted () {
    const ciaID = localStorage.getItem('smartmachCiaID')
    // this.ciaID = ciaID
    if (ciaID) {
      this.model.company = Number(ciaID)
    } 
    // console.log('store', this.$store.state.auth.company)
    console.log('show', this.showItem)
    this.btnDissmiss = this.$store.state.general.permission.dismiss_new_product_dialog,
    this.$watch('model.category', () => {
      this.$refs.alertCategory.style.display = 'none'
    })
    this.$watch('model.company', ()=>{
      this.vms = []
      this.lockers = []
      if(this.showItem) {
        this.getVm()      
      } else if (this.showMatriz) {
        this.getVm()
      } else {
        this.model.company = this.$store.state.auth.company
        this.getVm()
      }
      
    })
      if(this.showItem) {
        this.getVm()      
      } else if (this.showMatriz) {
      } else {
        this.model.company = this.$store.state.auth.company
        this.getVm()
      }

    
    //this.$store.dispatch('vmPrice/list')
  }, 
  methods: {
    ajustVariant () {
      console.log('variantes', this.variants)
      if (this.variants.length > 0) {
        for (let index = 0; index < this.variants.length; index++) {
          this.$store.dispatch('vmPrice/listSort', {sort: '?product_variant=' + 
            this.variants[index].id + '&page_size=50' }).then(resp => {
              var dif = this.vms.concat(this.lockers)
              if (resp.length << dif.length) {
                var inVms = dif.filter(this.comparer(resp))
                var conta = dif.length - resp.length
                for (let index = 0; index < conta; index++) {
                  var temp = {}
                  temp.price = ''
                  temp.company = inVms[index].company
                  temp.company_name = inVms[index].company_name
                  temp.product = resp[0].product
                  temp.product_name = resp[0].product_name
                  temp.product_variant = resp[0].product_variant
                  temp.product_variant_name = resp[0].product_variant_name
                  temp.vm = inVms[index].id
                  temp.vm_location = inVms[index].location
                  resp[resp.length]= temp
                }
                console.log('res', resp)
              }
                this.variants[index].vmprice = resp
          })
        }
      }
      console.log('variantes new', this.variants)
      console.log('pricesvarntes', this.pricesVariants)
    },
      comparer (otherArray){
        return function(current){
          return otherArray.filter(function(other){
            return other.vm == current.id 
          }).length == 0;
        }
      },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    onChange(event) {

      for (let i of event.target.files) {
        const reader = new FileReader();
        reader.onload = e => {
          const image = e.target.result;
          const title = i.name;
          this.images.push({ title, image });
        };
        console.log("i", i);
        this.hasImage = true;
        reader.readAsDataURL(i);
      }
    },
    skuExist (sku) {
      this.$store.dispatch('products/skuExist', {id: '?sku=' + sku}).then(data => {
        if (data.length) {
          skuDB = false
        } else {
        this.$store.dispatch('products/variants/skuExist', {id: '?sku=' + sku}).then(resp => {
          if (resp.length) {
            skuDB = false
          } else {
            skuDB = true
          }
        })
        }
        return true
      })
    },
    getVm () {
      var ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.idCia = Number(ciaID)
      } else if (this.showMatriz) {
        this.idCia= this.model.company
      } else {
        this.idCia = ''
      }
      console.log('cmodel', this.model.company)
      this.$store.dispatch('machines/get', {id: '?company=' + this.idCia + '&archived=False'}).then(resp => {
        this.vms = resp
      })
      this.$store.dispatch('lockers/listSort', {sort: '?company=' + this.idCia + '&archived=False'}).then(resp => {
        this.lockers = resp
        this.showPrices = true
      })
      if (this.$route.params.id) {
        this.$store.dispatch('vmPrice/listSort', {sort: '?product=' + this.$route.params.id + '&page_size=50'}).then(data =>{
          // this.finalPrice = data
          for (let index = 0; index < data.length; index++) {
            if (data[index].product_variant === null) {
              this.finalPrice[data[index].id] = data[index]  
              this.pricesVM[data[index].vm] = data[index].price  
            }
          }
        })
      }
    },
    imageUpload(product) {
      for (let i of this.images) {
        var image = {
          image: i.image,
          title: i.title,
          product: product
        };
        if (this.showMatriz) {
          image.company = this.model.company
        }
        console.log({ image });
        this.$store
          .dispatch("products/images/create", { item: image })
          .then(resp => {console.log('imagem', resp)
          if(!resp.ok) {
            this.notifyErrorImage()
          } else {
            this.notifySuccessImage()
          }
          });
      }
    },
    delImage (id) {
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) imagem.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("products/images/delete", { id }).then(resp => {
            setTimeout(() => {
              this.refreshImage();
            }, 700);
            this.showImage = false;
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    selectFile(e) {
      for (let index = 0; index < e.target.files.length; index++) {
        this.selectedFile.push(e.target.files[index]);
        this.paths.push(URL.createObjectURL(e.target.files[index]));
      }
      this.hasVideo = true;
    },
    delVideo(id) {
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) video.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("products/videos/delete", { id }).then(resp => {
            setTimeout(() => {
              this.refreshVideo();
            }, 600);
            this.showVideo = false;
          });
          swal.fire({
            title: "Pronto!",
            text: `${itemName} excluído(a).`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    videoUpload(product) {
      var formData = new FormData();
      for (let index = 0; index < this.selectedFile.length; index++) {
        if (this.showMatriz) {
          formData.append("company", this.model.company);
        }
        formData.append("title", this.selectedFile[index].name);
        formData.append("video", this.selectedFile[index]);
        formData.append("product", product);
        this.$store
          .dispatch("products/videos/createForm", { item: formData })
          .then(resp => {});
      }
    },
    saveEditAttribute(data, i, pos) {
      data.attributes[this.typeAttribute[pos]] = this.valueAttribute[pos];
      data.id = data.id + "/";
      this.$store
        .dispatch("products/variants/update", { item: data })
        .then(resp => {
          this.showVariant = false;
          this.refreshVariant();
        });
    },
    mountedData () {
      for (let index = 0; index < this.variantName.length; index++) {
        this.newVariant[index] = {
          'name' : this.variantName[index],
          'sku' : this.variantSku[index],
          'price_override' : 0.00,
          'product' : this.$route.params.id,
           attributes : {          
          }
        }
        for (let i = 0; i < this.countAttribute; i++) {
          this.newVariant[index].attributes[this.typeVariant[i]] = this.valueVariant[i]
        }
      }
    },
    putPrice (data) {
      console.log('data', data)
      console.log('vms', this.vms)
      console.log('lock', this.lockers)
      console.log('antes', this.finalPrice)
      console.log('leng', this.finalPrice.length)
      if (this.model.cost_price) {
        this.model.cost_price = this.model.cost_price.replace(",", ".")
      }

      var juntos
      juntos = this.vms.concat(this.lockers)
      console.log('juntos', juntos)

      
      if (this.crud === "Criar"){
        this.finalPrice[data.id] =  {
          vm: data.id,
          price: this.pricesVM[data.id].replace(",", "."),
          product: '',
          company: this.model.company
        }
      }
      if (this.crud === "Editar") {
        var exist = this.finalPrice.filter(v => {
          return v.vm === data.id
        })

        console.log('exist', exist)
        if (exist.length === 0) {
          this.finalPrice[data.id] =  {
            vm: data.id,
            price: this.pricesVM[data.id].replace(",", "."),
            product: '',
            company: this.model.company
          }
        }
        this.finalPrice.forEach(v => {
          console.log('produandasno', v.product_variant)
          if (v.product_variant !== undefined) {
            if (v.vm === data.id) {
              v.price = this.pricesVM[data.id].replace(",", ".")
            }
          }
        })
      }
      console.log('final do price', this.finalPrice)
    },
    putPriceVar (data) {
      console.log('data', data)
      console.log('antes', this.finalPriceVar)
      
      // if (this.crud === "Criar"){
        this.finalPriceVar[data.id] =  {
          vm: data.id,
          price: this.pricesVMVar[data.id].replace(",", "."),
          product: this.$route.params.id,
          company: this.model.company
        }
      // }
      if (this.crud === "Editar") {
        this.finalPriceVar.forEach(v => {
          if (v.vm === data.id) {
            v.price = this.pricesVMVar[data.id].replace(",", ".")
          }
        })
      }
      console.log('final', this.finalPriceVar)
    },
    deleteVariant (data) {
      var id = data.id
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a arquivar essa variação.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, arquive!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
        this.$store
        .dispatch("products/variants/updatePatch", {item: {
          id: id,
          archived: true }
          }).then(resp => {
          this.showVariant = false
          setTimeout(() => { this.refreshVariant() }, 500)
          console.log('resp', resp)
          if (resp.status !== 500) {
            swal.fire({
              title: "Pronto!",
              text: `Variação arquivada.`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          } else {
            swal.fire({
              title: "Ops!",
              text: `Variação não foi arquivada.`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
          }
        })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `Variação não foi arquivada.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteAttribute (data, i, n ) {
      delete data.attributes[n]
      var attributeremove = this.$store.state.products.variants.variants.filter(
        e => e.id == data.id
      )
      attributeremove[0].id = attributeremove[0].id + '/'
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) atributo.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("products/variants/update", { item: attributeremove[0]}).then(resp => {
            this.showVariant = false
            this.refreshVariant()
          })
          swal.fire({
            title: "Pronto!",
            text: `Atributo excluído(a).`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `Atributo não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    refreshImage () {
      this.$store.dispatch("products/images/list").then(data => {
        this.images = this.$store.state.products.images.images.filter(
          e => e.product == this.$route.params.id
        );
        this.imagesAPI = this.images
        this.images = []
        this.showImage = true
      })
    },
    refreshVideo() {
      this.$store.dispatch("products/videos/list").then(data => {
        this.videos = this.$store.state.products.videos.videos.filter(
          e => e.product == this.$route.params.id
        );
        this.videosAPI = this.videos;
        // this.videos = []
        this.showVideo = true;
      });
    },
    refreshVariant() {
      this.$store.dispatch("products/variants/list").then(data => {
        this.variants = this.$store.state.products.variants.variants.filter(
          e => e.product == this.$route.params.id
        )
        this.attributesList()
        this.typeAttribute = []
        this.valueAttribute = []
        this.typeVariant = []
        this.valueVariant = []
        this.countAttribute = 0
        this.showVariant = true
        this.ajustVariant()
      })
    },
    addVariant () {
      this.countVariant = this.countVariant + 1
    },
    addAttribute () {
      this.countAttribute = this.countAttribute + 1
    },
    removeAttribute () {
      this.countAttribute = this.countAttribute - 1
      this.typeVariant.splice(-1,1)
      this.valueVariant.splice(-1,1)
      this.typeAttribute.splice(-1,1)
      this.valueAttribute.splice(-1,1)
    },
    removeVariant () {
      this.countVariant = this.countVariant - 1
      this.typeVariant.splice(-1,1)
      this.valueVariant.splice(-1,1) 
      this.variantName.splice(-1,1)   
      this.variantSku.splice(-1,1) 
      this.variantPrice_override.splice(-1,1) 
    },
    removeVideo (index) { // ativar botão no html para utilizar
      this.paths.splice(index,1)
      this.selectedFile.splice(index,1)
    }, 
    removeImage (k) {
      this.images.splice(k,1)
    },
    removeVideo(index) {
      // ativar botão no html para utilizar
      this.paths.splice(index, 1);
      this.selectedFile.splice(index, 1);
    },
    removeImage(k) {
      this.images.splice(k, 1);
    },
    attributesList() {
      for (let index = 0; index < this.variants.length; index++) {
        this.attributeValue[index] = this.variants[index].attributes
      }
    },
    firstPass () {
      this.mountedData()
      setTimeout(() => { this.saveVariant () }, 500)
    },
    saveVariant () {
      if (this.countVariant !== 0) {
        for (let index = 0; index < this.countVariant; index++) {
          if (this.showMatriz) {
            this.newVariant[index].company = this.model.company
          }
          this.$store.dispatch("products/variants/create", {item: this.newVariant[index]}).then(data =>{
            for (let index = 0; index < this.finalPriceVar.length; index++) {
              if (this.finalPriceVar[index] !== undefined) {
                this.finalPriceVar[index].product_variant = data.id
                this.$store.dispatch('vmPrice/create', {item: this.finalPriceVar[index]})
              }
            }
          this.removeVariant()  
          })
        }
      } 

      this.showVariant = false
      setTimeout(() => { this.refreshVariant() }, 600)
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
      this.btnLoading = false
    },
    notifySuccessImage() {
      this.$notify({
        message: "Sucesso</br>Imagem Salva!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
      this.btnLoading = false
    },
    notifyError() {
      this.$notify({
        message: "Erro!</br>Item não salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
      this.btnLoading = false
    },
    notifyErrorImage() {
      this.$notify({
        message: "Erro!</br>Imagem não salva!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
      this.btnLoading = false
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      if (this.model.category === '') {
        this.$refs.alertCategory.style.display = 'block'
      }
      this.$validator.validateAll().then(isValid => {
        // this.model.price = this.model.price.replace(",", ".");
        this.mountedData()
        if (isValid && this.crud === "Criar") {
          this.btnLoading = true
          this.$store
            .dispatch("products/create", { item: this.model })
            .then(data => {
              if (data.id === undefined) {
                this.notifyError()
              } else {
                for (let index = 0; index < this.finalPrice.length; index++) {
                  if (this.finalPrice[index] !== undefined) {
                    this.finalPrice[index].product = data.id
                    this.$store.dispatch('vmPrice/create', {item: this.finalPrice[index]})
                  }
                }
                if (this.countVariant !== 0) {
                  for (let index = 0; index < this.countVariant; index++) {
                    this.newVariant[index].product = data.id
                    this.$store
                    .dispatch("products/variants/create", {item: this.newVariant[index]})
                  }
                }
                console.log("then", data);
                if (this.hasImage) {
                  this.imageUpload(data.id);
                }
                if (this.hasVideo) {
                  this.videoUpload(data.id);
                }
                if (this.btnDissmiss) {
                  this.finish();
                } else {
                  this.dialogAlert()
                }
              } 
            });
        } else if (isValid && this.crud === "Editar") {
          this.btnLoading = true
          this.$store
            .dispatch("products/update", { item: this.model })
            .then(data => {
              if (data.id === undefined) {
                this.notifyError()
              } else {
                console.log('final preço', this.finalPrice)
                for (let index = 0; index < this.finalPrice.length; index++) {
                  if (this.finalPrice[index] !== undefined) {
                    if (this.finalPrice[index].id === undefined) {
                      this.finalPrice[index].product = this.$route.params.id
                      console.log('ts', this.finalPrice[index])
                      this.$store.dispatch('vmPrice/create', {item: this.finalPrice[index]})
                    } else {
                      this.finalPrice[index].product = data.id
                      this.$store.dispatch('vmPrice/update', {item: this.finalPrice[index]})
                    }
                  }
                }
                for (let index = 0; index < this.variants.length; index++) {
                  this.variants[index].id = this.variants[index].id
                  this.$store.dispatch("products/variants/update", { item: this.variants[index] }).then(()=>{
                    for (let i = 0; i < this.variants[index].vmprice.length; i++) {
                      if (this.variants[index].vmprice[i].id) {
                        console.log('dentro')
                        this.$store.dispatch('vmPrice/update', {item: this.variants[index].vmprice[i]})
                      } else {
                        console.log('elsey')
                        this.$store.dispatch('vmPrice/create', {item: this.variants[index].vmprice[i]})
                      }
                    }
                  })
                }
                if (this.countVariant !== 0) {
                  for (let index = 0; index < this.countVariant; index++) {
                    this.$store.dispatch("products/variants/create", {item: this.newVariant[index]})
                  }
                }
                if (this.imagesAPI !== this.images) {
                  this.imageUpload(data.id);
                }
                if (this.hasVideo) {
                  this.videoUpload(data.id);
                }
                this.finish();
              }
            });
        }
      });
    },
    finish () {
      var payload
      payload = this.$store.state.general.permission
      // payload.company = this.model
      payload.dismiss_new_product_dialog = this.btnDissmiss
      this.$store.dispatch('general/dismiss',{item: payload, id: this.$store.state.general.permission.id_do_usuario})
      this.notifySuccess();
      this.$router.push(`/app/products/products`)
    },
    dialogAlert () {
      swal.fire({
        title: "Produto Criado",
        text: `Não se esqueça de colocar em uma mola`,
        icon: "success",
        confirmButtonClass: "btn btn-success btn-fill",
        buttonsStyling: false
      }).then(()=>{
        this.finish()
      })     
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
.label-add {
  margin-top: 20px;
}
.div-img {
  padding: 15px;
  display: inline-block;
}
.remove-attribute {
  padding: 1px;
  margin-top: 30px;
}
#linha {
  width: 100%;
  border-bottom: 1px solid #c5c0c0;
}
</style>
